module.exports = function () {
    const toggleBtn = document.getElementById('openCalendly');
    
    if (toggleBtn) {
        toggleBtn.addEventListener('click', toggleClasses)
    }

    function toggleClasses() {
        let selectBox = document.querySelector('.select-box');
        let calendlyWidget = document.querySelector('.calendly-inline-widget');
        let selectBoxCalendar = document.querySelector('.select-box-calendar');

        // selectBox.classList.toggle('opacity-0');
        selectBox.style.height = selectBox.clientHeight + 'px';
        setTimeout(() => {
            selectBox.style.height = calendlyWidget.clientHeight + 'px';
            selectBox.classList.toggle('pointer-events-none');  
            
            setTimeout(() => {
                selectBox.classList.toggle('opacity-0');
                selectBoxCalendar.classList.toggle('opacity-0');
            }, 500)
        }, 10)
    }
}